import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function Automating() {
    return (
        <OnboardingBody title='Automating attribution with Nutshell Analytics'>
            <p>
                We provide a small code snippet that can be embedded on your website to identify
                where site visitors are coming from.
            </p>
            <p>
                <strong>Nutshell Analytics</strong> will <i>automatically</i> add these sources to
                your leads.
            </p>
        </OnboardingBody>
    );
}
